import { useModal } from "../../../utils/ModalContext";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loginUser, getUser } from "./../../../utils/redux/slices/userSlice";
import { FiX, FiChevronRight } from "react-icons/fi";
import { X } from "lucide-react";
import LoginModalStyleWrapper from "./LoginModal.style";

import hoverShape from "../../../assets/images/icon/hov_shape_L.svg";
import { Label } from "../../../components/ui/label";
import Button from "../../../common/button";

const LoginModal = () => {
  const { closeLoginModalHandle } = useModal();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);

  const token = useSelector((state) => state?.user?.data?.data?._token);
  const useractual = useSelector((state) => state?.user?.user?.data);

  // useEffect(() => {
  //   if (useractual) {
  //     loginModalHandle();
  //   }
  // }, [useractual]);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchUser = async () => {
      if (token) {
        console.log("token dentro if", token);
        try {
          const userAction = await dispatch(getUser(token));

          if (getUser.fulfilled.match(userAction)) {
            closeLoginModalHandle();
          } else {
            console.error("getUser failed:", userAction.error);
          }
        } catch (error) {
          console.error("Error during getUser:", error);
        }
      }
    };

    fetchUser();
  }, [token, dispatch]);

  const handleInput = (type, e) => {
    const value = e.target.value;

    if (type === "email") {
      setEmail(value);
    }
    if (type === "password") {
      setPassword(value);
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const data = {
      email,
      password,
    };
    console.log("onSubmit", data);
    dispatch(loginUser(data));
  };

  return (
    <>
      <LoginModalStyleWrapper className="modal_overlay">
        <div className="mint_modal_box">
          <div className="mint_modal_content">
            <div className="modal_header">
              <h2>Login</h2>
              <button onClick={() => closeLoginModalHandle()}>
                <X className="mr-1" color="white" size={20} />
              </button>
            </div>
            <div className="text-center">
              <form onSubmit={onSubmit} className="">
                <div className="flex flex-col gap-4">
                  <div className="text-left">
                    <Label className="text-white">Email</Label>
                    <input
                      type="text"
                      placeholder="Email"
                      onChange={(e) => handleInput("email", e)}
                      value={email}
                    />
                  </div>

                  <div className="text-left">
                    <Label className="text-white">Password</Label>
                    <input
                      type="password"
                      placeholder="Password"
                      onChange={(e) => handleInput("password", e)}
                      value={password}
                    />
                  </div>
                </div>
                <div>
                  <Button className="mt-4 mx-auto p-2" variant="mint">
                    Login
                  </Button>
                </div>
              </form>
            </div>

            <div className="modal_bottom_shape_wrap">
              <span className="modal_bottom_shape shape_left">
                <img src={hoverShape} alt="bithu nft hover shape" />
              </span>
              <span className="modal_bottom_shape shape_right">
                <img src={hoverShape} alt="bithu nft hover shape" />
              </span>
            </div>
          </div>
        </div>
      </LoginModalStyleWrapper>
    </>
  );
};

export default LoginModal;
